import React, {Component} from "react";
import Cookies from "universal-cookie";

const cookies = new Cookies();

class Contacto extends Component {

    // remover todas las cookies al cerrar por seguridad
    cerrarSesion = () => {


        // redireccionar a login para HashRouter
        // el <Link to="#login"><Link/>
        //window.location.href='/login';
        window.location.href='https://jbteccr.net/testapp/#/Login';
        
    }

    render() {

        return(
            <div>
                Contactos en AWS

                <br/>
                <br/>
                <button className="btn btn-primary" onClick={() => this.cerrarSesion()}>Cerrar la Sesion de Contactos - ir a Login</button>

            </div>
        );
    }
}

export default Contacto;